import React, { useState, useEffect } from 'react';
import './OpenCallOrSms.css'; // Add your CSS file for styling
import axios from 'axios';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { encryptWithManagedIV } from '../../utils/DecryptingModule';
export default function OpenCallOrSms() {
  const { room } = useVideoContext();
  const { search, state } = useLocation();
  const [input, setInput] = useState<string>('');
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { URLRoomName } = useParams<{ URLRoomName?: string }>();
  const [roomName, setRoomName] = useState<string>('');
  const [UserName, setUserName] = useState<string>('');
  const [Link, Setlink] = useState<string>('');

  useEffect(() => {
    if (URLRoomName) {
      setRoomName(URLRoomName);
      const ContactPhoneNumber = (state as { state: { ContactPhoneNumber: string } }).state.ContactPhoneNumber;
      const ContactName = (state as { state: { ContactName: string } }).state.ContactName;
      const providerName = (state as { state: { providerName: string } }).state.providerName;
      setInput(ContactPhoneNumber);
      setUserName(providerName);
    }
  }, [URLRoomName]);

  const handleDigitClick = (digit: string) => {
    setInput(prevInput => prevInput + digit);
  };

  const handleClearClick = () => {
    setInput('');
  };

  const handlePlusClick = () => {
    setInput(prevInput => prevInput + '+');
  };

  const handleHashClick = () => {
    setInput(prevInput => prevInput + '#');
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const sanitizedValue = inputValue.replace(/[^0-9+]/g, ''); // Allow only numbers, plus, and hash

    setInput(sanitizedValue);
  };

  const handleBackspaceClick = () => {
    setInput(prevInput => prevInput.slice(0, -1));
  };

  const Sms = async () => {
    if (input.length === 0) {
      alert('Please enter a valid number');
    } else {
      const encryptionKeyBase64 = 'T543oUJD9RzlE7YzlGesLpqCL988CV1Zavj7hvjpTQw='; // Your encryption key

      // let abcd;
      const ContactPhoneNumber = (state as { state: { ContactPhoneNumber: string } }).state.ContactPhoneNumber;
      const RecordId = (state as { state: { RecordId: string } }).state.RecordId;
      const ContactName = (state as { state: { ContactName: string } }).state.ContactName;
      const ProviderId = (state as { state: { ProviderId: string } }).state.ProviderId;
      const Type = (state as { state: { Type: string } }).state.Type;
      const providerName = (state as { state: { providerName: string } }).state.providerName;
      const data1 = {
        RecordId: RecordId,
        ContactName: ContactName,
        ContactPhoneNumber: input,
        ProviderId: ProviderId,
        providerName: providerName,
        Type: 'Patient',
      };
      //console.log(data1);
      const abcd = await encryptWithManagedIV(data1, encryptionKeyBase64);
      //console.log(abcd, 'abcd');
      // encryptWithManagedIV(state.state, encryptionKeyBase64)
      //     .then(encryptedData => {
      //         abcd = encryptedData
      //         //console.log('Encrypted Data:', encryptedData);
      //         abcd = encryptedData
      //     })
      //     .catch(error => {
      //         console.error('Error:', error);
      //     });

      const response = await axios.post('https://avserver.jobsitecare.com/sms', {
        number: input,
        origin: window.location.origin,
        link: abcd,
        participantname: input,
        roomname: roomName,
        username: UserName,
      });
      //console.log(response);
      if (response.status) {
        alert('SMS has been sent successfully');
      }
      const btn = document.getElementById('closebutton')?.click();
    }
  };
  const Participants = async () => {
    if (room) {
      //console.log(room);

      const Data = Array.from(room?.participants.values(), p => ({
        participant: p.identity,
        dominantSpeakerStartTime: 0,
      }));
      //console.log(Data);
    }
  };
  const Call = async () => {
    //console.log(input);
    //console.log(input);
    if (input.length === 0) {
      alert('Please enter a valid number');
    } else {
      const response = await axios.post('https://avserver.jobsitecare.com/call', {
        number: input,
        participantname: input,
        roomname: roomName,
      });
      //console.log(response);
      if (response.status) {
        alert('Call Has Been Dialed Successfully');
      }
      const btn = document.getElementById('closebutton')?.click();
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Capture global keyboard events
  useEffect(() => {
    const handleGlobalKeyPress = (e: KeyboardEvent) => {
      const key = e.key;
      if (/[0-9+]/.test(key)) {
        setInput(prevInput => prevInput + key);
      } else if (key === 'Enter') {
        // Handle Enter key press (e.g., trigger SMS or Call)
        // You can add your logic here
      } else if (key === 'Backspace') {
        // Handle Backspace key press to erase one character
        handleBackspaceClick();
      }
    };

    document.addEventListener('keydown', handleGlobalKeyPress);

    return () => {
      document.removeEventListener('keydown', handleGlobalKeyPress);
    };
  }, []);

  return (
    <div className="button-container chatbox">
      <div className="row"> Invite patient via call or sms </div>
      <div className="row">
        {' '}
        <button className="callbtn" onClick={Call}>
          Call
        </button>{' '}
      </div>
      <div className="row">
        {' '}
        <button className="callbtn" onClick={Sms}>
          SMS
        </button>{' '}
      </div>

      {/* 
      <div className="button-container">
        <div className="button-container">
          <div className="row">
          </div>
          <div className="row">          
          </div>
          <div className="row">         
          </div>
          <div className="row">
          </div>
          <div className="row"></div>
          <div className="row buttonssms">
             <button onClick={Participants} className="callbtn">
              participants
            </button> 
          </div>
        </div>
      </div> */}
    </div>
  );
}
